import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/AuthContext';

export default function LoginPage() {
  const { t } = useTranslation();
  const { loginMosque } = useAuth();
  const navigate = useNavigate();

  const [form, setForm] = useState({ email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handle = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const data = await loginMosque(form.email, form.password);
      if (data?.mosque?.temp_password) {
        navigate('/admin/change-password');
      } else {
        navigate('/admin');
      }
    } catch (err) {
      const msg = err.response?.data?.error;
      if (msg === 'Invalid credentials') {
        setError('E-Mail oder Passwort ist falsch');
      } else if (msg === 'Account pending verification') {
        setError('Ihr Konto wird noch geprüft (24–48 Stunden)');
      } else if (msg === 'Account is blocked') {
        setError('Konto gesperrt. Kontakt: support@ilmify.ch');
      } else {
        setError(msg || 'Anmeldung fehlgeschlagen');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg)',
      padding: 20,
    }}>
      <div style={{ width: '100%', maxWidth: 400 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h1 style={{ fontFamily: 'Playfair Display', fontSize: 36, color: 'var(--primary-dk)', letterSpacing: -1 }}>
            Ilmi<span style={{ color: 'var(--accent)' }}>fy</span>
          </h1>
          <p style={{ color: 'var(--text3)', fontSize: 14 }}>Islamische Quiz-Plattform</p>
        </div>

        <div className="card">
          <h2 style={{ fontSize: 20, marginBottom: 4 }}>Anmelden</h2>
          <p style={{ color: 'var(--text3)', fontSize: 13, marginBottom: 20 }}>
            Moschee-Verwaltung
          </p>

          {error && <div className="alert alert-error">{error}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">{t('auth.email')}</label>
              <input
                className="form-input"
                type="email"
                name="email"
                value={form.email}
                onChange={handle}
                required
                autoFocus
                placeholder="ihre@email.ch"
              />
            </div>

            <div className="form-group">
              <label className="form-label">{t('auth.password')}</label>
              <input
                className="form-input"
                type="password"
                name="password"
                value={form.password}
                onChange={handle}
                required
                placeholder="••••••••"
              />
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 4, marginBottom: 4 }}>
              <Link to="/forgot-password" style={{ color: 'var(--text3)', fontSize: 13, textDecoration: 'none' }}>
                Passwort vergessen?
              </Link>
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-lg"
              style={{ width: '100%', marginTop: 12 }}
              disabled={loading || !form.email || !form.password}
            >
              {loading ? 'Laden...' : 'Anmelden'}
            </button>
          </form>

          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <Link to="/registrieren" style={{ color: 'var(--primary)', fontSize: 14 }}>
              Moschee noch nicht registriert? Jetzt registrieren
            </Link>
          </div>

          <div style={{
            borderTop: '1px solid var(--border)',
            marginTop: 20,
            paddingTop: 16,
            textAlign: 'center',
          }}>
            <p style={{ fontSize: 13, color: 'var(--text3)', marginBottom: 10 }}>
              Als Teilnehmer mitspielen:
            </p>
            <Link to="/join" className="btn btn-secondary">
              Mit PIN beitreten
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
